const brekkyCountdownBar = () => {
  // Find all countdown bars
  const countdownBars = document.querySelectorAll('[data-countdown-bar]');

  if (countdownBars.length === 0) return;

  // Function to position sticky bars
  const positionStickyBars = () => {
    const stickyBars = Array.from(countdownBars).filter(bar =>
      bar.hasAttribute('data-sticky')
    );
    const nonStickyBars = Array.from(countdownBars).filter(bar =>
      !bar.hasAttribute('data-sticky')
    );

    let topOffset = 0;
    stickyBars.forEach((bar) => {
      bar.style.position = 'fixed';
      bar.style.top = `${topOffset}px`;
      bar.style.left = '0';
      bar.style.right = '0';
      bar.style.zIndex = '1000';
      topOffset += bar.offsetHeight;
    });

    // Position non-sticky bars below sticky bars
    nonStickyBars.forEach((bar) => {
      bar.style.top = `${topOffset}px`;
    });

    return topOffset; // Return total height of sticky bars
  };

  // Function to adjust other elements based on sticky bars
  const adjustElementPositions = (totalBarHeight) => {
    // Adjust announcement-bar-section position
    const announcementBar = document.querySelector('.announcement-bar-section');
    if (announcementBar) {
      announcementBar.style.top = `${totalBarHeight}px`;
      announcementBar.style.marginTop = `${totalBarHeight}px`;
    }

    // Adjust section-header position (total bar height + 48px)
    const sectionHeader = document.querySelector('.section-header.shopify-section-group-header-group');
    if (sectionHeader) {
      sectionHeader.style.top = `calc(${totalBarHeight}px + 48px)`;
    }
  };

  // Main function to handle all positioning
  const handleCountdownBars = () => {
    const totalHeight = positionStickyBars();
    adjustElementPositions(totalHeight);
  };

  // Initialize positioning
  handleCountdownBars();

  // Recalculate after 2 seconds in case of delayed content
  setTimeout(handleCountdownBars, 1000);

  // Listen for resize events to recalculate positions
  window.addEventListener('resize', handleCountdownBars);
};

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', brekkyCountdownBar);
} else {
  brekkyCountdownBar();
}
